import { action, toJS, extendObservable } from "mobx";
import validate from "validate.js";
import moment from "moment";
import _ from "lodash";
import DataStore from "components/Store/DataStore";

validate.validators.isTrue = function(value, options, key, attributes) {
  if ([true, "true"].includes(value)) {
    return null;
  }
  return options.message || `${key} is required`;
};

validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse(value, options) {
    return +moment.utc(value);
  },
  // Input is a unix timestamp
  format(value, options) {
    const format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
    return moment.utc(value).format(format);
  },
});

class FormStore extends DataStore {
  constraints = {};
  errors = null;
  errorGlobal = null;
  errorGlobal2 = null;

  constructor(options = {}) {
    super(options);

    extendObservable(this, {
      constraints: {},
      errors: null,
      errorGlobal: null,
      errorGlobal2: null,
      resetValidation: action(this.resetValidation),
      validate: action(this.validate),
      isValid: action(this.isValid),
      validateAny: action(this.validateAny),
      setError: action(this.setError),
      setErrorGlobal: action(this.setErrorGlobal),
      setErrorGlobal2: action(this.setErrorGlobal2),
    });

    this.constraints = options.constraints;
  }

  clear() {
    super.clear();
    this.errors = null;
    this.errorGlobal = null;
    this.errorGlobal2 = null;
  }

  clearField(name) {
    if (this.errors && this.errors[name]) this.errors[name] = null;
  }

  onSet = (name, value) => {
    this.errors && this.errors[name] && this.validate([name]);
  };

  resetValidation() {
    this.errors = null;
    this.errorGlobal = null;
    this.errorGlobal2 = null;
  }

  async validate(fields) {
    const constraints = fields ? _.pick(this.constraints, fields) : this.constraints;

    const newErrors = validate(this.data, constraints, { fullMessages: false });

    this.errors = this.errors && fields ? { ..._.omit(this.errors, fields), ...newErrors } : newErrors;

    return this.errors;
  }

  async isValid(fields) {
    return !(await this.validate(fields));
  }

  async validateAny(fields, error) {
    const valid = fields.find(field => this.data[field]);

    this.errorGlobal = valid ? null : error;
    this.errorGlobal2 = valid ? null : error;

    return this.errorGlobal;
  }

  async setError(field, error) {
    this.errors = { ...(toJS(this.errors) || {}), [field]: [error] };

    return this.errors;
  }

  async setErrorGlobal(error) {
    this.errorGlobal = error;

    return this.errorGlobal;
  }

  async setErrorGlobal2(error) {
    this.errorGlobal2 = error;

    return this.errorGlobal2;
  }

  getFirstErrorName() {
    return (
      this.errors && Object.keys(this.errors) && Object.keys(this.errors).length > 0 && Object.keys(this.errors)[0]
    );
  }
}

export default FormStore;
